import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UserService} from "./user.service";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {UserModel, userModelFactory} from "../types/user.model";
import {AppSettingsService} from "../app-settings/app-settings.service";
import {Subscription} from "rxjs/Subscription";
import {handleErrors} from "../misc/handle-errors.decorator";

@Component({
  selector: "user-edit",
  templateUrl: "./user-edit.template.pug",
  providers: [UserService],
})
export class UserEditComponent extends RouteHelper implements OnInit, OnDestroy {
  userId: string;
  user: UserModel = userModelFactory();
  error: Error;
  rolesSelected: any[] = [];
  roles: any[] = [];
  alternateEmail: boolean = false;
  managers: string = "";
  isManager: boolean = false;
  private userSubscription: Subscription;

  paramsMap: RouteMapping[] = [
    {fieldName: "userId", paramName: "id"} as RouteMapping,
  ];

  navigate(queryParams: Params): Promise<boolean> {
    return this.router.navigate(["user-edit"], {queryParams});
  }

  @handleErrors()
  async loadData() {
    const {roles, userRoles, user} = await this.userService.getUserById(this.userId);

    this.roles = roles;

    this.rolesSelected = userRoles;

    if (!user) {
      throw new Error("User not found");
    }

    this.alternateEmail = (user.uid !== user.emailAddress);
    this.user = user as UserModel;
    this.managers = this.user.managers.join("\n");
  }

  constructor(
    private userService: UserService,
    public route: ActivatedRoute,
    public router: Router,
    public appSettingsService: AppSettingsService,
  ) {
    super();
  }

  @handleErrors()
  async save() {
    if (!this.user) return;

    if (!this.alternateEmail) this.user.emailAddress = this.user.uid;

    this.user.managers = this.managers.split("\n").map(it => `${it.trim()}`).filter(it => it);

    await this.userService.saveUserWithRoles(this.user, this.rolesSelected);

    this.router.navigate(["users"]);
  }

  cancel(): void {
    this.router.navigate(["users"]);
  }

  @handleErrors()
  async autofill() {
    const user = await this.userService.getNewUserInfo(this.user.uid);

    this.user = user;
    this.alternateEmail = (user.uid !== user.emailAddress);
  }

  ngOnInit() {
    super.ngOnInit();
    this.userSubscription = this.appSettingsService.user.subscribe((user) => {
      this.isManager = user.privilegeFlags.manager;
    });
  }

  ngOnDestroy() {
    if (this.userSubscription && !this.userSubscription.closed) {
      this.userSubscription.unsubscribe();
    }
  }
}
